import styled from "styled-components";

import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
export const IconWrapper = styled.figure`
	margin: 0;
	display: inline-block;
	line-height: 0;
	border-radius: 8px;
`;
export const FeatureCardsWrapper = styled.div`
	padding: 80px 0;
	.feature-card-heading-wrapper {
		display: flex;
		flex-direction: column;
		gap: ${(props) => (props.hasNumber ? `16` : `24`)}px;
		justify-content: center;
		align-items: center;
		text-align: center;
		${({ hasButtonAboveCards }) =>
			!hasButtonAboveCards ? "margin-bottom: 24px;" : ""}
	}
	.feature-card-star-rating {
		padding-top: 10px;
	}
	.feature-cards-btn {
		display: block;
		margin: auto;
	}
	.btn-margin-bottom {
		margin-bottom: 24px;
	}
	.btn-margin-top {
		margin-top: 24px;
	}
	${(props) =>
		props.hasHeadingContent
			? `padding-top:50px;
  `
			: `padding-top:0px;`}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 40px 0;
	}
`;

export const CardsWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 24px;
	justify-content: center;
`;

export const CardWrapper = styled.div`
	width: ${(props) =>
		props.hasNumber ? (props.cardsLength >= 4 ? `280px` : `293px`) : `30%`};
	max-width: 329px;
	padding: 32px 24px;
	border-radius: 8px;
	text-align: ${(props) => (props.hasNumber ? `start` : `center`)};
	.card-text-content-wrapper {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	${(props) =>
		!props.hasHeadingContent &&
		`padding-top: 0px;
`}
	${(props) =>
		props.hasBoxShadow &&
		`box-shadow: 0px 119px 48px rgba(135, 135, 135, 0.01), 0px 67px 40px rgba(135, 135, 135, 0.05), 0px 30px 30px rgba(135, 135, 135, 0.09), 0px 7px 16px rgba(135, 135, 135, 0.1), 0px 0px 0px rgba(135, 135, 135, 0.1);
`}
  display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${(props) => (props.hasNumber ? `24` : `32`)}px;

	background-color: var(--primary-neutral-white);
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		width: ${(props) => (props.hasNumber ? `293` : `329`)}px;
	}
`;
